<div [class.row]="twoColumns">
  <div [class.col-6]="twoColumns" *ngFor="let primaryType of categories | slice: 0:visibleLimit">
    <app-machine-category-media-card
      [category]="primaryType"
      [routerUrl]="['/equipment-rentals', primaryType.value, location]"
      [makes]="makes"
      (clearOutMakes)="clearOutMakes()"
    ></app-machine-category-media-card>
    <div class="mb-1"></div>
  </div>
</div>

<details class="mt-2" (toggle)="onToggle($event)" *ngIf="categories.length > visibleLimit">
  <summary class="btn btn-link p-0 ml-1 text-decoration-none text-green">{{ isExpanded ? "Show Less" : "Show All" }}</summary>
  <div class="mt-2" [class.row]="twoColumns">
    <div [class.col-6]="twoColumns" *ngFor="let primaryType of categories | slice: visibleLimit">
      <app-machine-category-media-card
        [category]="primaryType"
        [routerUrl]="['/equipment-rentals', primaryType.value, location]"
        [makes]="makes"
      ></app-machine-category-media-card>
      <div class="mb-1"></div>
    </div>
  </div>
</details>
